import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IBadgeCharity, IBadgeCharityDetails } from "../../models/badge_charity/response";
import { IBadgeCharityQuery } from "../../models/badge_charity/query";
import { ICreateBadgeCharity, IUpdateBadgeCharity } from "../../models/badge_charity/request";

export type BadgeCharityLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: BadgeCharityLoading[];
  list?: IBaseListingResponse<IBadgeCharity>;
  query: IBadgeCharityQuery;
  details?: IBadgeCharityDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IBadgeCharityDetails) => void;
    createBadgeCharity: (request: ICreateBadgeCharity) => void;
    updateBadgeCharity: (id: number, request: IUpdateBadgeCharity) => void;
    deleteBadgeCharity: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IBadgeCharityQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createBadgeCharity: DEFAULT_FUNCTION,
    updateBadgeCharity: DEFAULT_FUNCTION,
    deleteBadgeCharity: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const BadgeCharityContext = createContext(externalState);

export default BadgeCharityContext;